import React from "react";
import { useTranslation } from "react-i18next";
import "react-popper-tooltip/dist/styles.css";
import { useSelector } from "react-redux";
import { Text } from "../../../components/common/text/text";
import { UserInfos } from "../../../components/user-infos";
import { OriginType } from "../../../models/track-type.enum";
import { AppState } from "../../../store/app-state";
import PlanInfos from "../../plan-infos";
import Countdown from "../countdown/countdown";
import NotificationArea from "../notification-area/notification-area";
import {
  Container,
  HeaderContent,
  Notications,
  Plan,
  Title,
} from "./header.styled";
import { Helper } from "../helper";

interface HeaderPropos extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle?: string;
  originType?: OriginType;
  isSelecteds?: boolean;
  isControl?: boolean;
  loading?: boolean;
  showCountdown?: boolean;
  endDate?: Date;
}

const Header: React.FC<HeaderPropos> = ({
  className,
  title,
  subtitle,
  showCountdown,
  loading,
  endDate,
  ...props
}) => {
  const { t } = useTranslation();
  const auth = useSelector((state: AppState) => state.authState);
  return (
    <Container {...props} className={className}>
      <HeaderContent>
        <Title>
          <Text color="#fff" fontWeight={800} fontSize={22}>
            {title}
          </Text>
          <Text
            color="#9d4faa"
            fontWeight={800}
            fontSize={22}
            margin="0 0 0 .2rem"
          >
            {"//"}
          </Text>
        </Title>

        <Notications>
          {showCountdown && (
            <div>
              <Countdown
                title={t("private-home-page:tabs.trackContent.run")}
                loading={loading}
                endDate={endDate}
              />
            </div>
          )}
          <Helper />
          <Plan>
            <PlanInfos />
            <NotificationArea />
            <UserInfos
              username={auth.user?.name ?? ""}
              corporate={auth.user?.corporate?.name ?? ""}
            />
          </Plan>
        </Notications>
      </HeaderContent>
    </Container>
  );
};

export default Header;
